module.exports = __webpack_public_path__ + "logo.png?883a398dc8ceac0b7ca12736b4956f07";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 242
// module chunks = 0